<template>
  <div style="height: 70px; ">
    <el-col :span="18" :offset="2" style="line-height: 70px;height:100%">
      <div class="logo"  style="cursor: pointer;float: left;height:100%" @click="toindx">
        <img style="float: left;margin-right: 15px;height:100%" alt="logo" src=
          "data:image/png;base64,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"
        >
        <!-- <div class="title" >HUSHI</div> -->
      </div>
    </el-col>
    <el-col :span="2" >
      <div v-if="userinfo==null" style="float:right;font-size: 18px;font-family: PingFang SC;font-weight: 400;color: #25282e;cursor: pointer;line-height: 70px" @click="loginVisible=true">
        登录
      </div>
      <div v-else style="float:right;">
        <div class="logo"  style="height: 70px;position: relative">
          <img :src="userAvatar"  style="width: 50px;height: 50px;border-radius: 50%;" @click="clickUserInfo">
          <div v-show="userInfoShow" style="width: 221px;height:160px ;background: #fff;position: absolute;top: 70px;left: -180%; z-index:999;   background: #fff;box-shadow:rgba(0, 0.1, 0.4, 0.45) 0px 0px 0.525rem">
            <el-row style="height: 40%; width: 100%;    border-bottom: 0.00521rem solid hsla(0,0%,80%,.75);" >
              <el-col :span="8" :offset="2" style="height: 100%">
                <div class="logo" style="height: 100%">
                  <img :src="userAvatar"  style="width: 50px;height: 50px;border-radius: 50%;margin: auto;display: block">
                </div>
              </el-col>
              <el-col :span="14" style="height: 100%;text-align: left;" >
                <el-row style="height: 100%;  display: flex;align-items: center;"><span>{{ userinfo.userName }}</span></el-row>
<!--                <el-row style="height: 50%;display: flex; align-items: center;"><span>ID:{{ userinfo.userId }}</span></el-row>-->
              </el-col>
            </el-row>
            <el-row style="height: 60%">
                <ul class="ur_list">
                  <li class="logo" @click="myAccount">
                    <el-col :offset="3">我的账户</el-col>
                  </li>
                  <li class="logo" @click="exitLogin">
                    <el-col :offset="3" >退出登录</el-col>
                  </li>
                </ul>

            </el-row>
          </div>

        </div>
      </div>
    </el-col>



    <!--    登录-->
    <el-dialog class="login-register" shadow="hover"
      :visible.sync="loginVisible"
      width="30%"
      :before-close="handleClose">

        <div class="card" >
          <h3 class="titles">{{ activeTab === 'login' ? '欢迎登录' : '欢迎注册' }}</h3>
          <el-form ref="form" :model="form" :rules="rules" class="form" label-width="80px">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword" v-show="activeTab === 'register'">
              <el-input type="password" v-model="form.confirmPassword" placeholder="请再次输入密码"></el-input>
            </el-form-item>
<!--            <el-form-item >-->
              <el-button type="primary" class="button" @click="handleSubmit">{{ activeTab === 'login' ? '登录' : '注册' }}</el-button>
<!--            </el-form-item>-->
            <div class="bottom-link">
              {{ activeTab === 'login' ? '还没有账号？' : '已有账号？' }}<span class="link-text" @click="toggleTab">{{ activeTab === 'login' ? '立即注册' : '立即登录' }}</span>
            </div>
          </el-form>
        </div>
<!--      <span slot="footer" class="dialog-footer">-->
<!--  </span>-->
    </el-dialog>

  </div>
</template>

<script>
import {mapMutations} from "vuex";
export default {
  name: "heads",

  mounted() {
    let a=localStorage.getItem("userinfo")
    if (a!=undefined &&a!=null){
      this.userinfo=JSON.parse(localStorage.getItem('userinfo'))
    }
  },
  data() {
    return {
      userinfo:null,
      userInfoShow:false,
      loginVisible:false,
      loginShow:true,
      loginForm: {
        userName: '',
        password: '',
      },
      registerForm: {
        userName: '',
        password: '',
      },
      isClick:false,
      userAvatar: require("@/assets/toux.jpeg"),
      activeTab: 'login',
      form: {
        userName: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],

        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      rules1: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],

        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    ...mapMutations(['loginStatus','testlo','userInfo']),
    handleClose(){
        this.loginVisible=false
    },
    clickUserInfo(){
      this.userInfoShow=!this.userInfoShow
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.activeTab === 'login' ){
            this.$axios.post('/api/user/userLogin',this.form).then(res=>{
              if (res.data.status==10){
                this.$message({
                  message: '恭喜你，登录',
                  duration:2000,
                  type: 'success'
                });
                this.loginStatus({ Authorization:"res.data.data.userToken",AuthorExpireTime:"res.data.data.expireTime"})
                this.userInfo(res.data.data.userInfo)
                this.userinfo = JSON.parse(localStorage.getItem("userinfo"));
                setTimeout(function (){
                  // c.$router.push('/userCenter');
                  window.location.href='/index'
                },2000)
              }else {
                this.$message({
                  message: res.data.message,
                  type: 'warning',
                  duration:2000,
                });
              }
              this.isClick=false
            })
          }else {
            this.$axios.post('/api/user/addUser', this.form).then(res => {
              if (res.data.status == 10) {
                this.$message({
                  message: '恭喜你，注册成功',
                  duration: 2000,
                  type: 'success'
                });
                setTimeout(this.toggleTab, 2000)
              } else {
                this.$message({
                  message: res.data.message,
                  duration: 2000,
                  type: 'warning'
                });
              }
            })
          }
        }
      });
    },
    toggleTab() {

      this.activeTab = this.activeTab === 'login' ? 'register' : 'login';
      this.form.confirmPassword = '';
      this.$refs.form.clearValidate();
    },
    //退出登录
    exitLogin(){
      this.userinfo=null
      localStorage.removeItem('userinfo');
      this.$router.push('/index')
    },
    myAccount(){
      this.$router.push('/myAccount')
      this.clickUserInfo()
    },
    toindx(){
      this.$router.push('/index')
    }

  },
}
</script>

<style scoped>
.title{
  font-family: Russo One;
  color: #000;
  text-align: left;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
}
.logo{
  display: flex;
  align-items: center; /* 垂直居中 */
}
.ur_list{
  list-style: none;
  text-align: left;
  height: 100%;
}
.ur_list li{
  height: 50%;
}
.ur_list li:hover{
  background-color: #ebebeb;
  cursor: pointer ;
}
</style>
<style scoped>
.login-register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.card {
  width: 70%;
  margin: auto;
}

.form {
  padding: 10px;
}

.titles {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.button {
  width: 70%;
}

.bottom-link {
  text-align: center;
  margin-top: 20px;
}

.link-text {
  color: #dc3526;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/heads.vue